<template>
  <div id="app">
    <img
      src="./assets/zebra_black_Velo.svg"
      alt="musikwelle guggach zebra"
      width="130px"
      height="auto"
    >
    <aside class="  menu">
      <ul class="menu-list">
        <!-- <li>
          <a>
            <router-link to="/hello">Home</router-link>
          </a>
        </li> -->
        <li
          v-if="visible()"
          class="button is-danger"
          v-on:click="logout"
        >
          <a>Logout</a>
        </li>
      </ul>
      <ul
        v-if="visible()"
        class="menu-list"
      >
        <li>
          <router-link to="/hello">Alle Schichten</router-link>
        </li>
      </ul>
      <ul
        v-if="isAnAdmin"
        class="  menu-list"
      >
        <li>
          <router-link to="/admin">Schichten Zusammenstellen</router-link>
        </li>
        <li>
          <router-link to="/basicSettings">Voreinstellungen</router-link>
        </li>
        <li>
          <router-link to="/helferuebersicht">Helferübersicht</router-link>
        </li>
      </ul>

    </aside>

    <br><br>

    <router-view></router-view>

  </div>

</template>

<script>
import firebase from 'firebase'
// import { globalStore } from './main.js'

export default {
  name: 'app',

  data () {
    return {
      isAnAdmin: false
    }
  },

  // data () {
  //   return {
  //     localAdmin: globalStore.globalAdmin
  //   }
  // },

  // computed: {
  //   computedvar: function () {
  //     return globalStore.globalAdmin
  //   }
  // },
  created () {
    this.visibleAdmin()
  },
  updated () {
    this.visibleAdmin()
  },

  methods: {
    visible: function () {
      let currentUser = firebase.auth().currentUser
      if (currentUser) {
        return true
      } else return false
    },

    // visibleAdmin: function () {
    //   let currentUser = firebase.auth().currentUser
    //   if (currentUser && this.localAdmin.some(function (arrVal) {
    //     return currentUser.email === arrVal
    //   })) {
    //     return true
    //   } else return false
    // },
    visibleAdmin: function () {
      let currentUser = firebase.auth().currentUser

      if (currentUser) {
        firebase
          .firestore()
          .collection('users')
          .doc(firebase.auth().currentUser.uid)
          .get()
          .then((doc) => {
            if (doc.data().admin) {
              this.isAnAdmin = true
            }
          })
      }
    },

    logout: function () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace('login')
        })
    }
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.adminMenuVisible {
  display: block;
}
.adminMenuHidden {
  display: none;
}
</style>
